import { defaultTheme, muiTheme } from '../styles';
import { Theme } from '@emotion/react';

/**
 * A hook to get the MUI+Emotion Theme
 *
 * Extend with light/dark mode if needed
 */

export function useTheme(): Theme {
    const composedTheme = { ...defaultTheme, ...muiTheme };
    return composedTheme;
}
